import { render, staticRenderFns, recyclableRender, components } from "./bbs-item.vue?vue&type=template&id=592fd182&scoped=true&"
var renderjs
import script from "./bbs-item.vue?vue&type=script&lang=js&"
export * from "./bbs-item.vue?vue&type=script&lang=js&"
import style0 from "./bbs-item.vue?vue&type=style&index=0&id=592fd182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592fd182",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-bbs/components/bbs-item.vue"
export default component.exports